module.exports = __webpack_public_path__ + "img/seat-toggle.123dc244.gif";